import { Component, HostListener, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ArchiveService } from '../../share/service/archive.service';
import { NavigationService } from '../../share/service/navigation.service';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss'],
})
export class ArchiveComponent implements OnInit, OnDestroy, AfterViewInit {
  @HostListener('window:scroll', ['$event']) onScroll() {
    if (this.archiveService.loading) {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        const loaderLine = document.querySelector<HTMLElement>('.loader-line');
        if (loaderLine) {
          loaderLine.style.position = 'fixed';
        }
      } else {
        const loaderLine = document.querySelector<HTMLElement>('.loader-line');
        if (loaderLine) {
          loaderLine.style.position = 'relative';
        }
      }
    }
  }

  windowCouponAmount: string;

  constructor(
    public archiveService: ArchiveService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.archiveService.initComponent();
    this.windowCouponAmount = window['wf_sso_coupon_amount'];
  }

  ngAfterViewInit() {
    this.navigationService.restoreScrollPosition(100);
  }

  ngOnDestroy() {
    this.archiveService.ngOnDestroy();
  }

  postFilter() {
    this.archiveService.postFilter();
  }

  skipToContent(): void {
    this.navigationService.skipToMainContent();
  }
}

